document.addEventListener('DOMContentLoaded', function() {
    const canvas = document.getElementById('miCanvas');
    // Si el canvas no existe en la página, detenemos el script para evitar errores
    if (!canvas) return; 
    
    const ctx = canvas.getContext('2d');

    // --- CONFIGURACIÓN PRINCIPAL ---
    // Cambia este valor para hacer el balón tan grande o pequeño como quieras
    const radio = 23; 
    let velocidadX = 1.5; // Velocidad de rodado
    // -------------------------------

    // Hacer el canvas responsivo y calcular la altura automáticamente
    function resizeCanvas() {
        canvas.width = canvas.parentElement.clientWidth;
        canvas.height = (radio * 2) + 20; // Altura dinámica según el radio
    }
    
    window.addEventListener('resize', resizeCanvas);
    resizeCanvas(); // Ejecutar al cargar

    // Cargar el logo
    const logoBruselas = new Image();
    logoBruselas.src = "https://cdn.shopify.com/s/files/1/0663/4192/9005/files/Logo-positivo.png?v=1781635995";
    let logoCargado = false;
    logoBruselas.onload = () => { logoCargado = true; };

    let x = radio;
    let angulo = 0;

    function dibujarBalon(x, y, radio, angulo) {
        // --- Sombra proyectada ---
        ctx.save();
        ctx.translate(x, y + radio + 5); 
        ctx.scale(1, 0.25); 
        const gradienteSombra = ctx.createRadialGradient(0, 0, 0, 0, 0, radio * 0.9);
        gradienteSombra.addColorStop(0, 'rgba(0, 0, 0, 0.4)');
        gradienteSombra.addColorStop(1, 'rgba(0, 0, 0, 0)');
        ctx.beginPath();
        ctx.arc(0, 0, radio * 0.9, 0, Math.PI * 2);
        ctx.fillStyle = gradienteSombra;
        ctx.fill();
        ctx.restore();

        // --- Rotación ---
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angulo);

        // --- Esfera base (Efecto 3D) ---
        ctx.beginPath();
        ctx.arc(0, 0, radio, 0, Math.PI * 2);
        const gradienteEsfera = ctx.createRadialGradient(-radio * 0.3, -radio * 0.3, radio * 0.1, 0, 0, radio);
        gradienteEsfera.addColorStop(0, '#ffffff'); 
        gradienteEsfera.addColorStop(0.6, '#e0e0e0'); 
        gradienteEsfera.addColorStop(1, '#888888');   
        ctx.fillStyle = gradienteEsfera;
        ctx.fill();
        ctx.lineWidth = 1.5;
        ctx.strokeStyle = '#333';
        ctx.stroke();

        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';

        const gradienteParche = ctx.createRadialGradient(0, 0, 0, 0, 0, radio);
        gradienteParche.addColorStop(0, '#444');
        gradienteParche.addColorStop(1, '#111');

        // --- Centro del balón (Pentágono negro) ---
        ctx.fillStyle = gradienteParche;
        ctx.beginPath();
        for (let i = 0; i < 5; i++) {
            const a = (i * 2 * Math.PI) / 5 - Math.PI / 2;
            const px = Math.cos(a) * (radio * 0.38);
            const py = Math.sin(a) * (radio * 0.38);
            if (i === 0) ctx.moveTo(px, py);
            else ctx.lineTo(px, py);
        }
        ctx.closePath();
        ctx.fill();
        ctx.stroke();

        // --- Logo ---
        if (logoCargado) {
            const tamanoLogo = radio * 0.95; 
            ctx.drawImage(logoBruselas, -tamanoLogo / 2, -tamanoLogo / 2, tamanoLogo, tamanoLogo);
        }

        // --- Parches laterales ---
        for (let i = 0; i < 5; i++) {
            const a = (i * 2 * Math.PI) / 5 - Math.PI / 2;
            const px1 = Math.cos(a) * (radio * 0.38);
            const py1 = Math.sin(a) * (radio * 0.38);
            const px2 = Math.cos(a) * (radio * 0.85);
            const py2 = Math.sin(a) * (radio * 0.85);

            ctx.beginPath();
            ctx.moveTo(px1, py1);
            ctx.lineTo(px2, py2);
            ctx.stroke();

            ctx.save();
            ctx.beginPath();
            ctx.arc(0, 0, radio - 1, 0, Math.PI * 2);
            ctx.clip();
            
            ctx.beginPath();
            ctx.arc(px2, py2, radio * 0.3, 0, Math.PI * 2);
            ctx.fillStyle = gradienteParche;
            ctx.fill();
            ctx.stroke();
            
            ctx.restore(); 
        }
        ctx.restore();
    }

    function animar() {
        // clearRect es lo que hace que el fondo sea transparente en cada cuadro
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // El balón se dibuja tocando el borde inferior
        const y = canvas.height - radio - 10; 
        dibujarBalon(x, y, radio, angulo);

        x += velocidadX;
        angulo += velocidadX / radio;

        if (x + radio > canvas.width || x - radio < 0) {
            velocidadX = -velocidadX; 
        }
        requestAnimationFrame(animar);
    }
    
    animar();
});